import React, { useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from "react-router-dom";
import Select, { components } from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import "react-dropzone-uploader/dist/styles.css";
import DatePicker, { DateObject } from "react-multi-date-picker";
import swal from "sweetalert2";
import { toast } from 'react-toastify';
import axios from 'axios';

const AddBranch = () => {
    const [branch_name, setbranch_name] = useState('');
    const [existingManagebranch, setExistingManagebranch] = useState([]);
    const [existingfranchaise, setExistingfranchise] = useState([]);
    const [existingemail, setExistingemail] = useState([]);
    const [existingmobile, setExistingMobile] = useState([]);
    const baseURL = process.env.REACT_APP_API_BASE_URL;
    const [country, setCountry] = useState([]);
    const [state, setState] = useState([]);
    const [city, setCity] = useState([]);
    const [timezone, settimezone] = useState([]);
    const [selectedTimezone, setSelectedTimezone] = useState(null);
    const [currencyFormatOptions, setCurrencyFormatOptions] = useState([]);
    const [selectedCurrencyFormat, setSelectedCurrencyFormat] = useState(null);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedOpeningDate, setSelectedOpeningDate] = useState(null);
    // const [selectedOption, setSelectedOption] = useState(null);
    // const formattedOpeningDate = selectedOption?.format("YYYY-MM-DD");
    const [areaInput, setArea] = useState('');
    const [doorInput, setDoor] = useState('');
    const [pincodeInput, setPincode] = useState('');
    const [cityShortCodeInput, setCityShortCode] = useState('');
    const [businessMobileInput, setBusinessMobile] = useState('');
    const [businessEmailInput, setBusinessEmail] = useState('');
    const [locationUrlInput, setLocationUrl] = useState('');
    const [websiteUrlInput, setWebsiteUrl] = useState('');
    const [cinNoInput, setCinNo] = useState('');
    const [gstNoInput, setGstNo] = useState('');
    const [panNoInput, setPanNo] = useState('');
    // const [latitudeInput, setLatitude] = useState('');
    // const [longitudeInput, setLongitude] = useState(''); 
    const [bankNameInput, setBankName] = useState('');
    const [bankBranchInput, setBankBranch] = useState('');
    const [accountHolderInput, setAccountHolder] = useState('');
    const [accountNoInput, setAccountNo] = useState('');
    const [ifscCodeInput, setIfscCode] = useState('');
    const [descriptionInput, setDescription] = useState('');
    const [error, setError] = useState('');
    const [manageBranchType, setManageBranchType] = useState(0);
    const [businessName, setBusinessName] = useState('');
    const [franchiseName, setFranchiseName] = useState('');
    // const [showBlock, setShowBlock] = useState({ franchise: false, branch: true });
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`${baseURL}/managebranch`)
            .then(response => {
                setExistingManagebranch(response.data.data.data.map(managebranch => managebranch.branch_name.toLowerCase()));
                setExistingfranchise(
                    response.data.data.data
                        .filter(managebranch => managebranch.manage_branch_type === 1)
                        .map(managebranch => managebranch.franchise_name.toLowerCase())
                );
                setExistingMobile(response.data.data.data.map(managebranch => String(managebranch.business_mobile_no)));
                setExistingemail(
                    response.data.data.data
                        .map(managebranch => managebranch.business_email_id.toLowerCase())
                );
            })
            .catch(error => {
                console.error("Error fetching branch_name", error);
            });
    }, []);

    useEffect(() => {
        axios.get(`${baseURL}/country`)
            .then(res => {
                const formatted = res.data.map(country => ({
                    value: country.id,
                    label: country.name
                }));
                setCountry(formatted);
            })
            .catch(err => console.error("Error loading country", err));
    }, []);

    useEffect(() => {
        if (selectedCountry) {
            axios.get(`${baseURL}/state?country_id=${selectedCountry.value}`)
                .then(res => {
                    const formatted = res.data.data.map(state => ({
                        value: state.id,
                        label: state.state_name
                    }));
                    setState(formatted);
                    setCity([]);
                    setSelectedState(null);
                    setSelectedCity(null);
                })
                .catch(err => console.error("Error loading state", err));
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedState) {
            axios.get(`${baseURL}/city?state_id=${selectedState.value}`)
                .then(res => {
                    console.log(res.data.data);
                    const formatted = res.data.data.map(city => ({
                        value: city.sid,
                        label: city.name
                    }));
                    setCity(formatted);
                    setSelectedCity(null); // Reset city when state changes
                })
                .catch(err => console.error("Error loading cities", err));
        }
    }, [selectedState]);

    useEffect(() => {
        if (selectedCountry) {
            axios.get(`${baseURL}/timezone?country=${selectedCountry.label}`)
                .then(res => {
                    const formatted = res.data.data.map((timezone) => ({
                        value: timezone.sno,
                        label: `${timezone.country} (UTC ${timezone.utc_offset})`
                    }));
                    settimezone(formatted);
                    setSelectedTimezone(formatted[0]);
                })
                .catch(err => console.error("Error loading timezone", err));
        }
    }, [selectedCountry]);

    useEffect(() => {
        if (selectedCountry) {
            axios.get(`${baseURL}/currencyformat?country_name=${selectedCountry.label}`)
                .then(res => {
                    const formatted = res.data.data.map(currency => ({
                        value: currency.sno, // "INR"
                        label: `${currency.currency_code}`
                    }));
                    setCurrencyFormatOptions(formatted);
                    setSelectedCurrencyFormat(formatted[0]); // auto-select first if desired
                })
                .catch(err => console.error("Error loading currency format", err));
        }
    }, [selectedCountry]);

    const formatBranchName = (name) => {
        return name.charAt(0).toUpperCase() + name.slice(1);
    };

    const extractLatLngFromUrl = (url) => {
        const match = url.match(/@(-?\d+\.\d+),(-?\d+\.\d+)/);
        if (match) {
            return {
                lat: parseFloat(match[1]),
                lng: parseFloat(match[2]),
            };
        }
        return null;
    };

    const validateInput = () => {
        const newErrors = {};
        const strictUrlRegex = /^(https?:\/\/)([^\s$.?#].[^\s]*)$/i;
        if (showBlock.brnch) {
            if (!branch_name.trim()) {
                newErrors.branch_name = 'This Field is required.';
            } else if (!/^[A-Za-z\s]+$/.test(branch_name)) {
                newErrors.branch_name = 'Only text is valid.';
            } else if (existingManagebranch.includes(branch_name.trim().toLowerCase())) {
                newErrors.branch_name = 'Branch Name already exists.';
            }
        } else {
            if (!businessName.trim()) newErrors.businessName = 'This Field is required.';
            if (!franchiseName.trim()) {
                newErrors.franchiseName = 'This Field is required.';
            } else if (existingfranchaise.includes(franchiseName.trim().toLowerCase())) {
                newErrors.franchiseName = 'Franchise Name already exists.';
            }
        }

        if (!selectedCountry) newErrors.country = 'This Field is required.';
        if (!selectedState) newErrors.state = 'This Field is required.';
        if (!selectedCity) newErrors.city = 'This Field is required.';
        if (!areaInput.trim()) newErrors.area = 'This Field is required.';
        if (!doorInput.trim()) newErrors.door = 'This Field is required.';
        // if (!pincodeInput.trim()) newErrors.pincode = 'This Field is required.';
        if (!pincodeInput.trim()) {
            newErrors.pincode = 'This Field is required.';
        } else if (!/^\d{6}$/.test(pincodeInput.trim())) {
            newErrors.pincode = 'Pincode must be exactly 6 digits.';
        }
        if (!cityShortCodeInput.trim()) newErrors.cityShortCode = 'This Field is required.';
        if (!businessMobileInput.trim()) newErrors.businessMobile = 'This Field is required.';
        if (businessMobileInput.length < 10) {
            newErrors.businessMobile = 'Mobile Number must be 10 digits.';
        } else if (existingmobile.includes(businessMobileInput)) {
            newErrors.businessMobile = 'Mobile Number already exists.';
        }

        // console.log(existingemail);
        if (!businessEmailInput.trim()) {
            newErrors.businessEmail = 'This field is required.';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(businessEmailInput.trim())) {
            newErrors.businessEmail = 'Enter a valid email address.';
        } else if (businessEmailInput.length > 254) {
            newErrors.businessEmail = 'Email must be under 255 characters.';
        } else if (existingemail.includes(businessEmailInput.trim().toLowerCase())) {
            newErrors.businessEmail = 'Email already exists.';
        }

        if (!locationUrlInput.trim()) {
            newErrors.locationUrl = 'This field is required.';
        } else if (!strictUrlRegex.test(locationUrlInput.trim())) {
            newErrors.locationUrl = 'Enter a valid URL (must start with http:// or https://).';
        } else if (extractLatLngFromUrl(locationUrlInput) === null) {
            newErrors.locationUrl = "Not a Valid Location URL.";
        }

        if (!websiteUrlInput.trim()) {
            newErrors.websiteUrl = 'This field is required.';
        } else if (!strictUrlRegex.test(websiteUrlInput.trim())) {
            newErrors.websiteUrl = 'Enter a valid URL (must start with http:// or https://).';
        }

        if (!gstNoInput) newErrors.gstno = 'This Field is required.';
        if (!cinNoInput) newErrors.cino = 'This Field is required.';


        if (!selectedOpeningDate) newErrors.openingDate = 'This Field is required.';
        // if (!latitudeInput.trim()) newErrors.latitude = 'This Field is required.';
        // if (!longitudeInput.trim()) newErrors.longitude = 'This Field is required.';
        if (!selectedTimezone) newErrors.timezone = 'This Field is required.';
        if (!selectedCurrencyFormat) newErrors.currencyFormat = 'This Field is required.';
        if (!bankNameInput.trim()) newErrors.bankName = 'This Field is required.';
        if (!bankBranchInput.trim()) newErrors.bankBranch = 'This Field is required.';
        if (!accountHolderInput.trim()) newErrors.accountHolder = 'This Field is required.';

        if (!accountNoInput.trim()) {
            newErrors.accountNo = 'This Field is required.';
        } else if (accountNoInput.trim().length < 8) {
            newErrors.accountNo = 'This Field Requires Minimum 8 digits.';
        }
        if (!ifscCodeInput.trim()) {
            newErrors.ifscCode = 'This Field is required.';
        } else if (ifscCodeInput.trim().length < 10) {
            newErrors.ifscCode = 'This Field Requires Minimum 10 digits.';
        }

        setError(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = (event) => {
        event.preventDefault();

        if (!validateInput()) return;


        const formattedBranchName = formatBranchName(branch_name);
        const formattedOpeningDate = selectedOpeningDate?.format('YYYY-MM-DD');

        // const formattedmanagebranchName = formatmanagebranchName(branch_name);

        const postData = {
            branch_name: showBlock.brnch ? formattedBranchName : franchiseName,
            manage_branch_type: manageBranchType,
            business_name: showBlock.franchise ? businessName : undefined,
            franchise_name: showBlock.franchise ? franchiseName : undefined,
            country: selectedCountry?.value,
            state: selectedState?.value,
            city: selectedCity?.value,
            area: areaInput, // Get value from corresponding input
            door: doorInput, // Get value from corresponding input
            pincode: pincodeInput,
            // city_short_code: parseInt(cityShortCodeInput),
            city_short_code: cityShortCodeInput,
            business_mobile_no: businessMobileInput,
            business_email_id: businessEmailInput,
            location_url: locationUrlInput,
            website_url: websiteUrlInput,
            cin_no: cinNoInput,
            gst_no: gstNoInput,
            pan_no: panNoInput,
            opening_date: formattedOpeningDate, // Format this as YYYY-MM-DD
            // latitude: latitudeInput,
            // longitude: longitudeInput,
            time_zone: selectedTimezone?.value,  // Must be sno
            currency_format: selectedCurrencyFormat?.value, // Must be sno
            bank_name: bankNameInput,
            bank_branch: bankBranchInput,
            account_holder: accountHolderInput,
            account_no: accountNoInput,
            ifsc_code: ifscCodeInput,
            description: descriptionInput


        };


        // Send the request to the backend
        axios.post(`${baseURL}/managebranch`, postData)
            .then(response => {
                if (manageBranchType === 0) {
                    toast.success("Branch Created Successfully!");
                } else {
                    toast.success("Franchise Created Successfully!");
                }
                navigate('/manage-branch');

            })
            .catch(error => {
                toast.error("An error occurred while creating.");
                console.error("Error:", error);
            });
    };


    const ConfirmationModal = () => {
        // const formattedmanagebranchName = formatmanagebranchName(branch_name);
        const name = showBlock.managebranch ? formatBranchName(branch_name) : franchiseName;
        swal.fire({
            html: `
                      <div class="alert alert-success px-2 py-2" role="alert">
                          Are You Sure Want to Create Branch ${showBlock.managebranch ? 'Branch' : 'Franchise'}?
                          <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                      </div>
                      <p class="text-center"><b>${name}</b></p>
                      <div class="text-center">
                          <svg xmlns="http://www.w3.org/2000/svg" 
                          // viewBox="0 0 48 48" width="48" height="48">
                          // <defs>
                          // <style>.cls-2{fill:#273941}.cls-5{fill:#f6fafd}
                          // </style></defs>
                          // <g id="_03-smile" data-name="03-smile"><circle cx="24" cy="24" r="23" style="fill:#ffce52"/>
                          // <path class="cls-2" d="M24 39c-7.168 0-13-4.935-13-11h2c0 4.962 4.935 9 11 9s11-4.038 11-9h2c0 6.065-5.832 11-13 11zM20 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6zM38 21h-2c0-2.206-1.346-4-3-4s-3 1.794-3 4h-2c0-3.309 2.243-6 5-6s5 2.691 5 6z"/>
                          // <path d="M24 4c12.15 0 22 8.507 22 19h.975a23 23 0 0 0-45.95 0H2C2 12.507 11.85 4 24 4z" style="fill:#ffe369"/>
                          // <path d="M46 23c0 10.493-9.85 19-22 19S2 33.493 2 23h-.975c-.014.332-.025.665-.025 1a23 23 0 0 0 46 0c0-.335-.011-.668-.025-1z" style="fill:#ffb32b"/>
                          // <ellipse class="cls-5" cx="37" cy="9" rx=".825" ry="1.148" transform="rotate(-45.02 37 9)"/>
                          // <ellipse class="cls-5" cx="30.746" cy="4.5" rx=".413" ry=".574" transform="rotate(-45.02 30.745 4.5)"/>
                          // <ellipse class="cls-5" cx="34" cy="7" rx="1.65" ry="2.297" transform="rotate(-45.02 34 7)"/></g>
                          // </svg>
                      </div>
                  `,
            showCancelButton: true,
            confirmButtonText: 'Yes!',
            cancelButtonText: 'Cancel',
            reverseButtons: true,
            customClass: {
                title: 'fs-6',
                cancelButton: 'btn btn-sm btn-secondary',
                confirmButton: 'btn btn-sm btn-success',
                htmlContainer: 'text-left'
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                handleSubmit({ preventDefault: () => { } });
            }
        });
    };

    const [showBlock, setShowBlock] = useState({
        franchise: false,
        brnch: true
    });

    const DivExperience = (section) => {
        setShowBlock({
            franchise: section === 'franchise',
            brnch: section === 'brnch',
        });
        setManageBranchType(section === 'franchise' ? 1 : 0);
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0 mb-4">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 style={{ color: '#025d3a' }}>Create Branch</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Branch Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active"><Link to='/manage-branch'>Manage Branch</Link></li>
                    </ol>
                </div>
            </div>

            <form onSubmit={handleSubmit} >
                <div className="row mt-3">
                    <div className="col-lg-4 mb-4">
                        <div className='mt-4'>
                            <div className="form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="employee"
                                    value="brnch"
                                    onClick={() => DivExperience('brnch')}
                                    checked={showBlock.brnch}
                                />
                                <label className="form-check-label fs-6">
                                    Branch
                                </label>
                            </div>
                            <div className="form-check-inline">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="employee"
                                    value="franchise"
                                    onClick={() => DivExperience('franchise')}
                                    checked={showBlock.franchise}
                                />
                                <label className="form-check-label fs-6">
                                    Franchise
                                </label>
                            </div>
                        </div>
                    </div>
                    {showBlock.franchise && (
                        <>
                            <div className="col-lg-4 mb-4">
                                <label className="text-black font-w500 fs-7">Business Name<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Business Name"
                                    maxLength={200}
                                    value={businessName}
                                    onChange={(e) => setBusinessName(e.target.value)} />
                                {error.businessName && (<small className="text-danger">{error.businessName}</small>)}
                            </div>
                            <div className="col-lg-4 mb-4">
                                <label className="text-black font-w500 fs-7">Franchise Name<span className="required">*</span></label>
                                <input type="text" className="form-control" placeholder="Enter Franchise Name" maxLength={200}
                                    value={franchiseName}
                                    onChange={(e) => setFranchiseName(e.target.value)} />
                                {error.franchiseName && (<small className="text-danger">{error.franchiseName}</small>)}
                            </div>
                        </>
                    )}
                    {showBlock.brnch && (
                        <div className="col-lg-4 mb-4">
                            <label className="text-black font-w500 fs-7">Branch Name <span className="required">*</span></label>
                            <input type="text" className="form-control" placeholder="Enter Branch Name" maxLength={200}
                                value={branch_name}
                                onChange={(e) => setbranch_name(e.target.value)} />
                            {error.branch_name && (<small className="text-danger">{error.branch_name}</small>)}
                        </div>
                    )}
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Country <span className="required">*</span></label>
                        <Select placeholder='Select Country'
                            value={selectedCountry}
                            onChange={setSelectedCountry}
                            options={country}
                        />
                        {error.country && <small className="text-danger">{error.country}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">State <span className="required">*</span></label>
                        <Select placeholder='Select State'
                            value={selectedState}
                            onChange={setSelectedState}
                            options={state}
                        />
                        {error.state && <small className="text-danger">{error.state}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">City <span className="required">*</span></label>
                        <Select placeholder='Select city'
                            value={selectedCity}
                            onChange={setSelectedCity}
                            options={city}
                        />
                        {error.city && <small className="text-danger">{error.city}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Area / Street<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Area / Street" maxLength={200} value={areaInput} onChange={(e) => setArea(e.target.value)} />
                        {error.area && <small className="text-danger">{error.area}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Door / Flat No<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Door / Flat No" maxLength={150} value={doorInput} onChange={(e) => setDoor(e.target.value)} />
                        {error.door && <small className="text-danger">{error.door}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Pincode<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Pincode" value={pincodeInput}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Allow only digits, max length 6
                                if (/^\d*$/.test(value) && value.length <= 6) {
                                    setPincode(value);
                                }
                            }} />
                        {error.pincode && <small className="text-danger">{error.pincode}</small>}
                    </div>
                    
                  
                    
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">
                            City Short Code<span className="required">*</span>
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            placeholder="Enter City Short Code"
                            value={cityShortCodeInput}
                            onChange={(e) => {
                            const value = e.target.value;
                            // Allow any characters, limit to 20 characters
                            if (value.length <= 20) {
                                setCityShortCode(value);
                            }
                            }}
                        />
                        {error.cityShortCode && (
                            <small className="text-danger">{error.cityShortCode}</small>
                        )}
                    </div>
                    
                    
                    
                    
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Business Mobile No<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Business Mobile No" value={businessMobileInput}
                            onChange={(e) => {
                                const value = e.target.value;
                                // Allow only digits and limit to 10 characters
                                if (/^\d*$/.test(value) && value.length <= 10) {
                                    setBusinessMobile(value);
                                }
                            }} />
                        {error.businessMobile && (<small className="text-danger">{error.businessMobile}</small>)}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Business Email ID<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Business Email ID" maxLength={100}
                            value={businessEmailInput}
                            onChange={(e) => setBusinessEmail(e.target.value)} />
                        {error.businessEmail && (<small className="text-danger">{error.businessEmail}</small>)}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Location URL<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Location URL" value={locationUrlInput} maxLength={450}
                            onChange={(e) => setLocationUrl(e.target.value)} />
                        {error.locationUrl && (<small className="text-danger">{error.locationUrl}</small>)}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Website URL<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Website URL" value={websiteUrlInput} maxLength={450}
                            onChange={(e) => setWebsiteUrl(e.target.value)} />
                        {error.websiteUrl && (<small className="text-danger">{error.websiteUrl}</small>)}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">CIN No<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter CIN No" value={cinNoInput} maxLength={150}
                            onChange={(e) => setCinNo(e.target.value)} />
                        {error.cino && <small className="text-danger">{error.cino}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">GST No<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter GST No" value={gstNoInput} maxLength={200}
                            onChange={(e) => setGstNo(e.target.value)} />
                        {error.gstno && <small className="text-danger">{error.gstno}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">PAN No</label>
                        <input type="text" className="form-control" placeholder="Enter PAN No" maxLength={150}
                            value={panNoInput}
                            onChange={(e) => setPanNo(e.target.value)} />
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Opening Date<span className="required">*</span></label>
                        <div className='datepicker-wrapper d-flex'>
                            <div className='input-group-text bg-transparent border-0 px-0'><i className='fa-solid fa-calendar-days fs-4'></i></div>
                            <DatePicker
                                value={selectedOpeningDate}
                                onChange={setSelectedOpeningDate}
                                format="YYYY-MM-DD"
                                placeholder='Select Date of Birth'
                                minDate={new Date().setHours(0,0,0)}
                            />
                        </div>
                        {error.openingDate && (<small className="text-danger">{error.openingDate}</small>)}
                    </div>
                    {/* <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Latitude<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Latitude" value={latitudeInput}
                        onChange={(e) => setLatitude(e.target.value)}/>
                        {error.latitude && <small className="text-danger">{error.latitude}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Longitude<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Longitute" value={longitudeInput}
                        onChange={(e) => setLongitude(e.target.value)} />
                        {error.longitude && <small className="text-danger">{error.longitude}</small>}
                    </div> */}
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Time Zone <span className="required">*</span></label>
                        <Select placeholder='Select Time Zone'
                            value={selectedTimezone}
                            onChange={setSelectedTimezone}
                            options={timezone}
                        />
                        {error.timezone && <small className="text-danger">{error.timezone}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Currency Format <span className="required">*</span></label>
                        <Select placeholder='Select Currency Format'
                            value={selectedCurrencyFormat}
                            onChange={setSelectedCurrencyFormat}
                            options={currencyFormatOptions}
                        />
                        {error.currencyFormat && (<small className="text-danger">{error.currencyFormat}</small>)}
                    </div>
                </div>
                <label className='text-red fs-4 font-w600 mb-3'>Bank Information</label>
                <div className="row">
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Bank Name<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Bank Name" value={bankNameInput} maxLength={200}
                            onChange={(e) => {
                                const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                setBankName(onlyAlphabets);
                            }}
                        />
                        {error.bankName && <small className="text-danger">{error.bankName}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Bank Branch<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Bank Branch" value={bankBranchInput} maxLength={200}
                            onChange={(e) => {
                                const onlyAlphabets = e.target.value.replace(/[^a-zA-Z0-9\s]/g, '');
                                setBankBranch(onlyAlphabets);
                            }}
                        />
                        {error.bankBranch && (<small className="text-danger">{error.bankBranch}</small>)}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Account Holder<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Account Holder" value={accountHolderInput} maxLength={200}
                            onChange={(e) => {
                                const onlyAlphabets = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                                setAccountHolder(onlyAlphabets);
                            }}
                        />
                        {error.accountHolder && (<small className="text-danger">{error.accountHolder}</small>)}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">Account No<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter Account No" value={accountNoInput} maxLength={15}
                            // onChange={(e) => setAccountNo(e.target.value)}
                            onChange={(e) => {
                                const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                                setAccountNo(onlyNums);
                            }} 
                        />
                        {error.accountNo && <small className="text-danger">{error.accountNo}</small>}
                    </div>
                    <div className="col-lg-4 mb-4">
                        <label className="text-black font-w500 fs-7">IFSC Code<span className="required">*</span></label>
                        <input type="text" className="form-control" placeholder="Enter IFSC Code" value={ifscCodeInput} maxLength={15} 
                            onChange={(e) => {
                                const onlyNums = e.target.value.replace(/[^a-zA-Z0-9]/g, '');
                                setIfscCode(onlyNums);
                            }}
                        />
                        {error.ifscCode && <small className="text-danger">{error.ifscCode}</small>}
                    </div>
                    <div className='col-lg-4 mb-4'>
                        <label className="text-black font-w500 fs-7">Description</label>
                        <textarea rows={1} className="form-control" name="comment" placeholder="Description"
                            value={descriptionInput} maxLength={255}
                            onChange={(e) => setDescription(e.target.value)} />
                    </div>
                </div>
                {error.form && <div className="text-danger mb-3">{error.form}</div>}
                <div className="d-flex align-items-center justify-content-end gap-3 mt-4">
                    <Link to={'/manage-branch'} type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                    <button onClick={handleSubmit} type="button" className="btn btn-sm btn-primary">Create {showBlock.brnch ? 'Branch' : 'Franchise'}</button>
                </div>
            </form>
        </>
    )


}
export default AddBranch;